/**
 * Public API for Marketplace
 * This is the public API for the Marketplace service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CompleteApplePurchase403Response { 
    error_key?: CompleteApplePurchase403Response.ErrorKeyEnum;
}
export namespace CompleteApplePurchase403Response {
    export type ErrorKeyEnum = 'user.blocked' | 'user.deleted';
    export const ErrorKeyEnum = {
        Blocked: 'user.blocked' as ErrorKeyEnum,
        Deleted: 'user.deleted' as ErrorKeyEnum
    };
}


